export default __webpack_public_path__ + "21b3848a32fce5b0f5014948186f6964.woff2";